<template>
    <div v-if="ui.features.highlights.opened" dusk="ReaderHightlights" class="flex flex-1 flex-col overflow-hidden">
        <ExportNotesOrHighlight
            :highlights="highlightsList"
            :checked-colors="checkedColors"
            @checked-colors="colors => (checkedColors = colors)"
        />
        <div class="flex-1 overflow-y-auto overflow-x-hidden">
            <div
                v-if="selectionsIsEmpty"
                role="status"
                aria-live="polite"
                class="flex h-full w-full items-center justify-center px-4 text-center text-theme-text"
            >
                <p class="text-sm opacity-60">
                    {{ localizations[lang].noHighlights }}
                </p>
            </div>
            <div
                v-else-if="highlightsList.length === 0"
                role="status"
                aria-live="polite"
                class="flex h-full w-full items-center justify-center px-4 text-center text-theme-text"
            >
                <p class="text-sm opacity-60">
                    {{ localizations[lang].noFilterHighlightsColor }}
                </p>
            </div>
            <template v-else>
                <SectionLabel>{{ highlightsList.length }} {{ localizations[lang].highlights }}</SectionLabel>
                <HighlightAndNotesText :highlights="highlightsList" />
            </template>
        </div>
    </div>
</template>

<script>
'use strict';

import { mapGetters, mapState } from 'vuex';
import HighlightAndNotesText from '../partials/HighlightAndNotesText.vue';
import ExportNotesOrHighlight from '../partials/ExportNotesOrHighlight.vue';
import SectionLabel from '../partials/SectionLabel.vue';
import checkedColorsMixin from '_shared_/js/mixins/checkedColorsMixin';

export default {
    components: {
        HighlightAndNotesText,
        ExportNotesOrHighlight,
        SectionLabel,
    },

    mixins: [checkedColorsMixin],

    computed: {
        ...mapState(['ui', 'localizations', 'lang', 'selections', 'sharedColors']),
        ...mapGetters(['allHighlighters']),

        highlightsList() {
            return this.selections.filter(selection => {
                return this.checkedColors.includes(selection.colorSlug) && !selection.hasAnnotation;
            });
        },

        selectionsIsEmpty() {
            return this.selections.filter(s => !s.hasAnnotation).length === 0;
        },
    },
};
</script>
